import { useLocation, useNavigate } from 'react-router';

import styles from './styles.module.css';
import { TabType } from './types';
import { useNavigationBar } from '@/context/NavigationBarContext';

function Tabs() {
  const location = useLocation();
  const navigate = useNavigate();
  const { tabsSegment, activeTabId } = useNavigationBar();

  const handleTabClick = (tab: TabType) => {
    if (tab.onClick) {
      tab.onClick(tab.id);
    } else if (tab.path) {
      navigate(tab.path);
    }
  };

  const isTabActive = (tab: TabType) => {
    if (activeTabId) {
      return activeTabId === tab.id;
    }
    if (tab.path) {
      return location.pathname.includes(tab.path);
    }
    return false;
  };

  return (
    <div className={styles.tabsContainer}>
      {tabsSegment.length > 0 &&
        tabsSegment.map((tab: TabType) => (
          <span
            key={tab?.id}
            className={isTabActive(tab) ? styles.tabActive : styles.tab}
            onClick={() => handleTabClick(tab)}
          >
            {tab?.label}
          </span>
        ))}
    </div>
  );
}

export default Tabs;
